<template>
  <role-form-modal
    :header-title="pageTitle"
    :header-content="pageDesc"
    :header-title-icon="pageIcon"
    :initial-role-name="$t(`ROLES.NAMES.${name}`)"
    :initial-permissions="mergedPermissions"
    :initial-inbox-permissions="initialInboxPermissions"
    :read-only="readOnly"
    :read-only-name="readOnlyName"
    :on-close="onClose"
  >
    <template
      #footer="{
        roleName,
        permissions: formPermissions,
        inboxPermissions: formInboxPermissions,
        isValid,
      }"
    >
      <woot-button
        v-if="!readOnly"
        class="cancel-filter-btn button clear text-base px-5 py-3 leading-[20px] h-[48px] font-[400]"
        color-scheme="secondary"
        @click.prevent="onClose"
      >
        {{ $t('ROLES.EDIT.CANCEL') }}
      </woot-button>
      <woot-submit-button
        v-if="!readOnly"
        :disabled="!isValid || uiFlags.isUpdating || name === 'General Manager'"
        :button-text="$t('ROLES.EDIT.SUBMIT')"
        :loading="uiFlags.isUpdating"
        class="button-filled text-base px-5 py-3 font-[400] h-[48px]"
        @click.native.prevent="
          editRole(roleName, formPermissions, formInboxPermissions)
        "
      />
      <woot-button
        v-if="readOnly"
        class="cancel-filter-btn button clear text-base px-5 py-3 leading-[20px] h-[48px] font-[400]"
        color-scheme="secondary"
        @click.prevent="onClose"
      >
        {{ $t('ROLES.VIEW.CLOSE') }}
      </woot-button>
    </template>
  </role-form-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { GENERAL_PERMISSIONS, INBOX_PERMISSIONS } from './constants';
import RoleFormModal from './RoleFormModal.vue';

export default {
  components: { RoleFormModal },
  props: {
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    onClose: {
      type: Function,
      required: true,
    },
    permissions: {
      type: Object,
      required: true,
    },
    inboxPermissions: {
      type: Array,
      required: true,
    },
    readOnlyName: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      initialInboxPermissions: [],
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'roles/getUIFlags',
      inboxes: 'inboxes/getInboxes',
    }),
    pageTitle() {
      if (this.readOnly) {
        return this.$t('ROLES.VIEW.TITLE');
      }
      return this.$t('ROLES.EDIT.TITLE');
    },
    pageDesc() {
      if (this.readOnly) {
        return this.$t('ROLES.VIEW.DESC');
      }
      return this.$t('ROLES.MODAL_DESC');
    },
    pageIcon() {
      return this.readOnly ? 'visibility' : 'edit';
    },
    mergedPermissions() {
      return { ...GENERAL_PERMISSIONS, ...this.permissions };
    },
    readOnly() {
      return this.name === 'General Manager';
    },
  },
  async created() {
    this.initialInboxPermissions = this.buildInitialInboxPermissions();
  },
  methods: {
    buildInitialInboxPermissions() {
      return INBOX_PERMISSIONS.map(permission => {
        const existingPermission = this.inboxPermissions.find(
          p => p.name === permission
        );
        const ids = this.inboxes.reduce((acc, inbox) => {
          acc[inbox.id] = existingPermission
            ? existingPermission.ids[inbox.id] || false
            : false;
          return acc;
        }, {});
        return existingPermission
          ? { ...existingPermission, ids }
          : { name: permission, ids, default: false };
      });
    },
    showAlert(message) {
      bus.$emit('newToastMessage', message);
    },
    async editRole(roleName, permissions, inboxPermissions) {
      try {
        const payload = {
          id: this.id,
          permissions,
          inbox_permissions: inboxPermissions,
        };
        if (!this.readOnlyName) {
          payload.name = roleName;
        }
        await this.$store.dispatch('roles/update', payload);
        this.showAlert(this.$t('ROLES.EDIT.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        this.showAlert(error.message);
      }
    },
  },
};
</script>
